// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/collapse/style/index.less
// module id = 1092
// module chunks = 1